import { database } from '@/firebase'


export function convertDate(date) {
  let d = new Date(0)
  d.setUTCSeconds(date.seconds)
  return d.toDateString()
}

export function getCurrentUser(email) {
  return new Promise((resolve, reject) => {
    let retUser
    database.collection('Users')
      .where('email', '==', email)
      .get().then(snap => {
        snap.forEach(doc => {
          retUser = doc.data()
        })
        resolve(retUser)
      })
  }) 
}

export const permissions = {
  admin: 0,
  affiliate: 1,
  inventor: 2,
  guest: 3
}

export const permissionNames = [
  'Admin',
  'Affiliato',
  'Inventor',
  'Guest'
]

export function matchesPermission(requiredLevel, currentLevel) {
  return currentLevel <= requiredLevel ? true : false
}


// WEBPACK FOOTER //
// ./src/helpers/index.js